import { render, staticRenderFns } from "./EditBannerModal.vue?vue&type=template&id=59dc6481&scoped=true"
import script from "./EditBannerModal.vue?vue&type=script&lang=js"
export * from "./EditBannerModal.vue?vue&type=script&lang=js"
import style0 from "./EditBannerModal.vue?vue&type=style&index=0&id=59dc6481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dc6481",
  null
  
)

export default component.exports